var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewsletterSignupForm',{attrs:{"listId":_vm.campaignMonitorListId,"inputPlaceholder":_vm.inputPlaceholder,"submitButtonText":_vm.$t('sign_up'),"successMessage":_vm.successMessage,"errorMessage":_vm.errorMessage,"theme":_vm.THEMES.dark}})}
var staticRenderFns = []

export { render, staticRenderFns }